export const MercedesMail = (props) => (
    <svg width={props.size || 24}
        height={props.size || 24} viewBox="0 0 20 21" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg"{...props}>
        <path d="M9.99992 10.3975L18.2674 5.34166C18.2036 5.19091 18.0967 5.0623 17.9602 4.9719C17.8237 4.88149 17.6636 4.8333 17.4999 4.83333H2.49992C2.3362 4.8333 2.1761 4.88149 2.03961 4.9719C1.90311 5.0623 1.79627 5.19091 1.73242 5.34166L9.99992 10.3975Z" fill="black" />
        <path d="M10.0003 11.8625L1.66699 6.76582V15.6667C1.66699 15.8877 1.75479 16.0996 1.91107 16.2559C2.06735 16.4122 2.27931 16.5 2.50033 16.5H17.5003C17.7213 16.5 17.9333 16.4122 18.0896 16.2559C18.2459 16.0996 18.3337 15.8877 18.3337 15.6667V6.76666L10.0003 11.8625Z" fill="black" />
    </svg>
);

